export default {
  showSlide: 'Show slide {number} of {count}',
};
